import React from "react";
import {
  BOOST_LEGAL_ESIGN_URL,
  BOOST_LEGAL_PRIVACY_POLICY_URL,
  BOOST_LEGAL_TERMS_AND_CONDITIONS_URL,
  BOOST_LEGAL_TERMS_OF_USE_URL,
} from "components/Pages/Boost/consts";
import {
  ISSUING_LEGAL_ESIGN_URL,
  ISSUING_LEGAL_AUTHORIZED_USER_TERMS_URL,
} from "components/Pages/Issuing/constants";

export const LEGAL_LINK_TYPES = {
  ESIGN: "ESIGN",
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
  TERMS_OF_USE: "TERMS_OF_USE",
  PRIVACY_POLICY: "PRIVACY_POLICY",
  ISSUING_ESIGN: "ISSUING_ESIGN",
  ISSUING_AUTHORIZED_USER_TERMS: "ISSUING_AUTHORIZED_USER_TERMS",
};

export const LEGAL_LINK_CONFIG = {
  [LEGAL_LINK_TYPES.ESIGN]: {
    text: "e-Sign",
    url: BOOST_LEGAL_ESIGN_URL,
  },
  [LEGAL_LINK_TYPES.TERMS_AND_CONDITIONS]: {
    text: "Terms and Conditions",
    url: BOOST_LEGAL_TERMS_AND_CONDITIONS_URL,
  },
  [LEGAL_LINK_TYPES.TERMS_OF_USE]: {
    text: "Terms of Use",
    url: BOOST_LEGAL_TERMS_OF_USE_URL,
  },
  [LEGAL_LINK_TYPES.PRIVACY_POLICY]: {
    text: "Privacy Policy",
    url: BOOST_LEGAL_PRIVACY_POLICY_URL,
  },
  [LEGAL_LINK_TYPES.ISSUING_ESIGN]: {
    text: "Stripe E-Sign Disclosure",
    url: ISSUING_LEGAL_ESIGN_URL,
  },
  [LEGAL_LINK_TYPES.ISSUING_AUTHORIZED_USER_TERMS]: {
    text: "Authorized User Terms (Celtic Bank)",
    url: ISSUING_LEGAL_AUTHORIZED_USER_TERMS_URL,
  },
};

export const LegalLink = ({ type, className }) => {
  if (!type) {
    return null;
  }

  return (
    <a
      href={LEGAL_LINK_CONFIG[type].url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {LEGAL_LINK_CONFIG[type].text}
    </a>
  );
};
